import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';

import GetFreeTrialButton from 'components/GetFreeTrialButton';
import Button from 'components/Button';
import { QuestionIcon } from 'components/Icon';
import useGetFreeTrialInfo from 'hooks/useGetFreeTrialInfo';

import CourseContext from 'routes/course/components/CourseContext';

import { toggleSocialWidget } from 'reduxModules/socialWidget/action';
import { getReport } from 'reduxModules/report/selector';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import { COURSE_DETAIL_ASK } from 'constants/gtmEvent';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ReportCTA.scss';

function ReportCTA() {
  useStyles(styles);
  const { t } = useTranslation(['course']);
  const dispatch = useDispatch();
  const { isReportFormOpen } = useSelector(getReport);

  const { id, title, courseEventTrackData } = useContext(CourseContext);
  const { faqTitleText } = useGetFreeTrialInfo();

  const handleClick = () => {
    if (isReportFormOpen) {
      return;
    }
    dispatch(toggleSocialWidget());
    dispatch(
      sendGTMEvent({
        eventName: COURSE_DETAIL_ASK,
        data: courseEventTrackData,
      }),
    );
  };

  return (
    <div className={styles.root}>
      <QuestionIcon />
      <h6 className={styles.title}>{faqTitleText}</h6>
      <div className={styles.buttonGroup}>
        <GetFreeTrialButton type="course" id={id} name={title} section="faq" />
        <Button
          reversed
          type="primary"
          onClick={handleClick}
          text={t(`features.faqHelp.contactBtn`)}
        />
      </div>
    </div>
  );
}

export default ReportCTA;
